import navigation_autoHideOnScreenSize from "../../../../core/model2/navigation/actions/auto-hide-on-screen-size";
import {UIType} from "../../../ui/@const";

// const debug = "navigation_autoHideToMoreVertical"
const debug = false

export default function navigation_autoHideToMoreVertical() {

    // we cannot just use HTML value ... becuase on window resize neadekvat izza proishodyachego ...


    // const navigationPanelDom = document.getElementsByClassName('ui-navigation')[0] as any
    // const panelHeight = navigationPanelDom.offsetHeight
    //
    // const topNode = navigationPanelDom.getElementsByClassName('top-container')[0]
    // const bottomNode = navigationPanelDom.getElementsByClassName('bottom')[0]
    //
    // const topHeight = topNode.offsetHeight
    // const bottomHeight = bottomNode.offsetHeight

    // Experimental based on js calculations
    const panelHeight   = gd.layout.height // total height for th etop panel (from html ? )
    const topHeight     = gd.navigationStructure.topSectionsTotalHeight
    const bottomHeight  = gd.navigationStructure.bottomSectionsTotalHeight


    debug && console.log(debug, "panel=", panelHeight, "top=", topHeight, "bottom=", bottomHeight)

    let heightMissing   : number   = 0
    let filledHeight    : number   = 0

    switch (gd.ui.type) {

        case UIType.CLICK_UP:
            filledHeight = topHeight + gd.ui.navbarButtonSize * 2 // why ?
        break

        case UIType.GOODDAY_MODERN:
        case UIType.TEAMS:
        default:
            filledHeight = topHeight + bottomHeight
    }

    if (panelHeight < filledHeight) {
        heightMissing = filledHeight - panelHeight
    }

    debug && console.log(debug, "missing height = ", heightMissing)
    navigation_autoHideOnScreenSize(heightMissing, 'height')


    return false

}
